<template>
  <el-aside width="230px" class="sidebar">
    <el-menu v-if="!isCostApp"
      class="el-menu-vertical-demo"
      background-color="#333"
      text-color="#fff"
      active-text-color="#ffd04b"
      :default-active="activeMenuItem"
    >
      <el-menu-item index="/users" @click="handleMenuClick('/users')" v-if="hasAccess(adminRoles, adminReadOnlyRoles)">
        <span>Пользователи</span>
      </el-menu-item>

      <el-menu-item index="/students" @click="handleMenuClick('/students')" v-if="hasAccess(adminRoles, adminReadOnlyRoles, managerRoles, universityManagerRoles)">
        <span>Обучающиеся</span>
      </el-menu-item>

      <el-menu-item index="/military-students" @click="handleMenuClick('/military-students')" v-if="hasAccess(adminRoles, adminReadOnlyRoles, managerRoles, universityManagerRoles)">
        <span>Военная кафедра</span>
      </el-menu-item>

      <el-menu-item index="/student-credits" @click="handleMenuClick('/student-credits')" v-if="hasAccess(universityManagerRoles, managerRoles)">
        <span>Корректировка кредитов</span>
      </el-menu-item>

      <el-menu-item index="/students-social-groups" @click="handleMenuClick('/students-social-groups')" v-if="hasAccess(universityManagerRoles, managerRoles)">
        <span>Социальные группы</span>
      </el-menu-item>

      <el-menu-item index="/students-social-payment" @click="handleMenuClick('/students-social-payment')" v-if="hasAccess(universityManagerRoles, managerRoles)">
        <span>Социальные выплаты</span>
      </el-menu-item>

      <el-menu-item index="/student-training-duration" @click="handleMenuClick('/student-training-duration')" v-if="hasAccess(universityManagerRoles, managerRoles)">
        <span>Количества месяцев обучения</span>
      </el-menu-item>

      <el-menu-item index="/students-grants-nutrition" @click="handleMenuClick('/students-grants-nutrition')"
                    v-if="(hasAccess(universityManagerRoles) && isUniversity(UniversityEnum.KAZAKH_NATIONAL_WOMEN_PEDAGOGICAL_UNIVERSITY)) || hasAccess(managerRoles) || hasAccess(adminRoles, adminReadOnlyRoles)">
        <span>Питание студентов-грантников</span>
      </el-menu-item>

      <el-menu-item index="/students-marine-practice" @click="handleMenuClick('/students-marine-practice')" v-if="hasAccess(universityManagerRoles, managerRoles)">
        <span>Морская практика</span>
      </el-menu-item>

      <el-menu-item index="/students-flight-practice" @click="handleMenuClick('/students-flight-practice')" v-if="hasAccess(universityManagerRoles, managerRoles)">
        <span>Летная практика</span>
      </el-menu-item>

      <el-menu-item index="/acts/reconciliation" @click="handleMenuClick('/acts/reconciliation')" v-if="hasAccess([...managerRoles, ...adminRoles, ...adminReadOnlyRoles])">
        <span>Сверка актов</span>
      </el-menu-item>
      <el-menu-item index="/acts/acceptance" @click="handleMenuClick('/acts/acceptance')" v-if="hasAccess([...managerRoles, ...adminRoles, ...adminReadOnlyRoles])">
        <span>Принятие актов</span>
      </el-menu-item>

      <el-menu-item index="/invoice/reconciliation" @click="handleMenuClick('/invoice/reconciliation')"
                    v-if="hasAccess([...managerRoles, ...adminRoles, ...accountantRoles, ...universityManagerRoles])">
        <span>Работа с ЭСФ</span>
      </el-menu-item>

      <el-menu-item index="/eco-payment" @click="handleMenuClick('/eco-payment')"
                    v-if="(hasAccess(universityManagerRoles) && isUniversity(UniversityEnum.KORKYT_ATA_KYZYLORDA_UNIVERSITY)) || hasAccess(managerRoles) || hasAccess(adminRoles, adminReadOnlyRoles)">
        <span>Экологическая выплата</span>
      </el-menu-item>

      <el-menu-item index="/advance-deduction" @click="handleMenuClick('/advance-deduction')"
                    v-if="hasAccess([...managerRoles, ...adminRoles, ...adminReadOnlyRoles])">
        <span>Авансирование/Удержание</span>
      </el-menu-item>

      <el-menu-item index="/intergov-expenses" @click="handleMenuClick('/intergov-expenses')"
                    v-if="hasAccess([...managerRoles, ...adminRoles, ...adminReadOnlyRoles]) || isUniversity(UniversityEnum.NUR_MUBARAK)">
        <span>Расходы по межправ</span>
      </el-menu-item>

      <el-menu-item index="/reports" @click="handleMenuClick('/reports')"
                    v-if="hasAccess(universityManagerRoles, managerRoles, universityRectorRoles, adminRoles, auditRoles, adminReadOnlyRoles)">
        Отчеты
      </el-menu-item>

      <el-menu-item index="/reports-1course" @click="handleMenuClick('/reports-1course')"
                    v-if="hasAccess(universityManagerRoles, managerRoles, universityRectorRoles, adminRoles, auditRoles, adminReadOnlyRoles)">
        Отчеты(первокурсники)
      </el-menu-item>
      <el-menu-item index="/reports-1c" @click="handleMenuClick('/reports-1c')" v-if="hasAccess(accountantRoles, adminRoles, adminReadOnlyRoles)">
        Отчеты на 1С
      </el-menu-item>
      <el-menu-item index="/summary-social-reports" @click="handleMenuClick('/summary-social-reports')" v-if="hasAccess(managerRoles, adminRoles)">
        Сводный отчет (Соц)
      </el-menu-item>
      <el-menu-item index="/summary-reports" @click="handleMenuClick('/summary-reports')" v-if="hasAccess(managerRoles, adminRoles)">
        Сводный отчет
      </el-menu-item>
      <el-menu-item index="/dictionaries" @click="handleMenuClick('/dictionaries')" v-if="hasAccess(adminRoles, adminReadOnlyRoles)">
        <span>Справочники</span>
      </el-menu-item>

      <el-menu-item index="/settings" @click="handleMenuClick('/settings')" v-if="hasAccess(adminRoles)">
        <span>Настройки</span>
      </el-menu-item>

      <el-menu-item index="/events" @click="handleMenuClick('/events')" v-if="hasAccess(adminRoles, adminReadOnlyRoles)">
        <span>Логи пользователей</span>
      </el-menu-item>
    </el-menu>

    <el-menu v-if="isCostApp"
             class="el-menu-vertical-demo"
             background-color="#333"
             text-color="#fff"
             active-text-color="#ffd04b"
             :default-active="activeMenuItem" :default-openeds="['expenses']"
    >


      <el-sub-menu index="expenses"
                   v-if="hasAccess([...managerRoles, ...adminRoles, ...adminReadOnlyRoles, ...universityManagerRoles])" >
        <template #title>
          <span>Расходы</span>
        </template>
        <el-menu-item index="/expenses/salary-bonus" @click="handleMenuClick('/expenses/salary-bonus')">
          <span>111 - Зарплата</span>
        </el-menu-item>
        <el-menu-item index="/expenses/treatment-benefit" @click="handleMenuClick('/expenses/treatment-benefit')">
          <span>113 - Лечпособие</span>
        </el-menu-item>
        <el-menu-item index="/expenses/ue-opvr" @click="handleMenuClick('/expenses/ue-opvr')">
          <span>116 - ОПВР</span>
        </el-menu-item>
        <el-menu-item index="/expenses/ue-social-tax" @click="handleMenuClick('/expenses/ue-social-tax')">
          <span>121 - Соцналог</span>
        </el-menu-item>
        <el-menu-item index="/expenses/ue-social-deduction" @click="handleMenuClick('/expenses/ue-social-deduction')">
          <span>122 - Соцотчисл</span>
        </el-menu-item>
        <el-menu-item index="/expenses/ue-osms" @click="handleMenuClick('/expenses/ue-osms')">
          <span>124 - ВОСМС</span>
        </el-menu-item>
        <el-menu-item index="/expenses/insurance-worker" @click="handleMenuClick('/expenses/insurance-worker')">
          <span>123 - ОГПО работдатель</span>
        </el-menu-item>
        <el-menu-item index="/expenses/insurance-transport" @click="handleMenuClick('/expenses/insurance-transport')">
          <span>123 - ОГПО транспорт</span>
        </el-menu-item>
        <el-menu-item index="/expenses/insurance-transfer" @click="handleMenuClick('/expenses/insurance-transfer')">
          <span>123 - ОГПО перевозка</span>
        </el-menu-item>
        <el-menu-item index="/expenses/nutrition" @click="handleMenuClick('/expenses/nutrition')">
          <span>141 - Питание</span>
        </el-menu-item>
        <el-menu-item index="/expenses/water" @click="handleMenuClick('/expenses/water')">
          <span>141 - Вода</span>
        </el-menu-item>
        <el-menu-item index="/expenses/medicines" @click="handleMenuClick('/expenses/medicines')">
          <span>142 - Медикаменты</span>
        </el-menu-item>
        <el-menu-item index="/expenses/gsm" @click="handleMenuClick('/expenses/gsm')">
          <span>144 - Гсм</span>
        </el-menu-item>
        <el-menu-item index="/expenses/coal" @click="handleMenuClick('/expenses/coal')">
          <span>144 - Уголь дт</span>
        </el-menu-item>
        <el-menu-item index="/expenses/materials" @click="handleMenuClick('/expenses/materials')">
          <span>149 - Материалы</span>
        </el-menu-item>
        <el-menu-item index="/expenses/central-heating" @click="handleMenuClick('/expenses/central-heating')">
          <span>151 - Центротопление</span>
        </el-menu-item>
        <el-menu-item index="/expenses/electricity" @click="handleMenuClick('/expenses/electricity')">
          <span>151 - Электр</span>
        </el-menu-item>
        <el-menu-item index="/expenses/water-heating" @click="handleMenuClick('/expenses/water-heating')">
          <span>151 - Подогрев</span>
        </el-menu-item>
        <el-menu-item index="/expenses/wastewater" @click="handleMenuClick('/expenses/wastewater')">
          <span>151 - Вода</span>
        </el-menu-item>
        <el-menu-item index="/expenses/waste" @click="handleMenuClick('/expenses/waste')">
          <span>151 - мусор</span>
        </el-menu-item>
        <el-menu-item index="/expenses/communications" @click="handleMenuClick('/expenses/communications')">
          <span>152 - связь</span>
        </el-menu-item>
        <el-menu-item index="/expenses/transport" @click="handleMenuClick('/expenses/transport')">
          <span>153 - транспуслуги</span>
        </el-menu-item>
        <el-menu-item index="/expenses/research" @click="handleMenuClick('/expenses/research')">
          <span>154 - Исследования</span>
        </el-menu-item>
        <el-menu-item index="/expenses/consulting" @click="handleMenuClick('/expenses/consulting')">
          <span>156 - Консультац</span>
        </el-menu-item>
        <el-menu-item index="/expenses/image" @click="handleMenuClick('/expenses/image')">
          <span>157 - Имиджевые</span>
        </el-menu-item>
        <el-menu-item index="/expenses/it" @click="handleMenuClick('/expenses/it')">
          <span>158 - ИТ</span>
        </el-menu-item>
        <el-menu-item index="/expenses/building-content" @click="handleMenuClick('/expenses/building-content')">
          <span>159 - Содержаниезд</span>
        </el-menu-item>
        <el-menu-item index="/expenses/students" @click="handleMenuClick('/expenses/students')">
          <span>159 - Студенты</span>
        </el-menu-item>
        <el-menu-item index="/expenses/trips-local" @click="handleMenuClick('/expenses/trips-local')">
          <span>161 - Команд РК</span>
        </el-menu-item>
        <el-menu-item index="/expenses/trips-foreign" @click="handleMenuClick('/expenses/trips-foreign')">
          <span>162 - Команд за РК</span>
        </el-menu-item>
        <el-menu-item index="/expenses/social-help" @click="handleMenuClick('/expenses/social-help')">
          <span>163 - Матпомощь</span>
        </el-menu-item>
        <el-menu-item index="/expenses/other-gph" @click="handleMenuClick('/expenses/other-gph')">
          <span>169 - Прочие гпх</span>
        </el-menu-item>
        <el-menu-item index="/expenses/international" @click="handleMenuClick('/expenses/international')">
          <span>169 - Международные</span>
        </el-menu-item>
        <el-menu-item index="/expenses/tax" @click="handleMenuClick('/expenses/tax')">
          <span>000 - Налоги</span>
        </el-menu-item>
        <el-menu-item index="/expenses/writeoff" @click="handleMenuClick('/expenses/writeoff')">
          <span>000 - Списание</span>
        </el-menu-item>
        <el-menu-item index="/expenses/depreciation" @click="handleMenuClick('/expenses/depreciation')">
          <span>000 - Износ</span>
        </el-menu-item>
        <el-menu-item index="/expenses/loans" @click="handleMenuClick('/expenses/loans')">
          <span>000 - Займы</span>
        </el-menu-item>
        <el-menu-item index="/expenses/contingent" @click="handleMenuClick('/expenses/contingent')">
          <span>Контингент</span>
        </el-menu-item>
        <el-menu-item index="/expenses/summary-calculated" @click="handleMenuClick('/expenses/summary-calculated')">
          <span>свод расчетные</span>
        </el-menu-item>
        <el-menu-item index="/expenses/summary-vuz-svod" @click="handleMenuClick('/expenses/summary-vuz-svod')">
          <span>ВУЗ СВОД</span>
        </el-menu-item>
      </el-sub-menu>
      <el-menu-item index="pdf" @click="handleMenuPdf('/docs/cost-instruction.pdf')">
        <span>  База знаний</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue";
import {useRouter} from "vue-router";
import authService from "@/services/authService";
import publicService from "@/services/publicService";
import {UniversityEnum} from "@/enum/UniversityEnum";

export default defineComponent({
  name: "MenuComponent",
  computed: {
    UniversityEnum() {
      return UniversityEnum
    }
  },
  setup() {
    const activeMenuItem = ref("/directory");
    const router = useRouter();
    const isCostApp = window.location.hostname.includes('cost');
    const currentUser = ref({universityId: 0});

    if (window.location.hostname == 'cost.fincenter.kz') {
      alert('Внимание! Сайт временно недоступен. Пожалуйста, используйте чуть позже');
      location.href = 'https://cost.fincenter.kz/login';
    }

    const adminRoles: string[] = authService.getAdminRoles();
    const adminReadOnlyRoles: string[] = authService.getAdminReadOnlyRoles();

    const managerRoles: string[] = authService.getManagerRoles();
    const accountantRoles: string[] = authService.getAccountantRoles();
    const universityManagerRoles: string[] = authService.getUniversityManagerRoles();
    const universityRectorRoles: string[] = authService.getUniversityRectorRoles();
    const auditRoles: string[] = authService.getAuditRoles();

    const handleMenuClick = (path: string) => {
      activeMenuItem.value = path;
      router.push(path);
    };

    const handleMenuPdf = (pdfUrl: string) => {
      window.open(pdfUrl, '_blank')
    }

    const hasAccess = (...roleGroups: string[][]) => {
      const allRoles = roleGroups.flat();
      return authService.hasAccess(allRoles);
    };

    const getCurrentUserInfo = async () => {
      try {
        currentUser.value = await publicService.getCurrentUserInfo();
      } catch (error) {
        console.error("Failed to fetch current user info:", error);
      }
    };

    const isUniversity = (university: any) => {
      return currentUser.value.universityId == university.id;
    };

    getCurrentUserInfo();

    return {
      activeMenuItem,
      handleMenuClick,
      handleMenuPdf,
      hasAccess,
      adminRoles,
      adminReadOnlyRoles,
      managerRoles,
      accountantRoles,
      universityManagerRoles,
      universityRectorRoles,
      auditRoles,
      isUniversity,
      currentUser,
      isCostApp
    };
  },
});
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  background-color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 20px;
}

.sidebar-logo {
  margin-bottom: 20px;
}

.logo {
  height: 60px;
}

.el-menu-vertical-demo {
  width: 100%;
  border-right: none;
  margin-top: 60px;
}

.el-menu-item {
  padding-left: 24px;
}

.el-menu-item:hover {
  background-color: #34495e !important;
}
</style>
